import React from 'react';
import DeleteIconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';

import { CAN_EDIT_TEAM_MEMBERS } from '../../constants/permissions';
import { DELETE_MEMBER } from '../../apis/member';
import Button from '../atoms/button';
import deleteImg from '../../images/deleteIcon.svg';
import useLoader from '../../context/LoaderContext';
import useProjectVersionHistory from '../../context/VersionHistoryContext';
import useWorkspace from '../../context/WorkspaceContext';

const propTypes = {
  epicsId: PropTypes.number,
};
const deleteIconButton = (props) => {
  const { setIsLoading } = useLoader();
  const [open, setOpen] = React.useState(false);
  const [deleteMember] = useMutation(DELETE_MEMBER);
  const { userPermissions } = useWorkspace();
  const permissions = [];
  const {
    setUndoEdits,
    setRedoEdits,
    selectedListItem,
    showVersionHistoryBar,
    readOnlyMode,
  } = useProjectVersionHistory();
  if (userPermissions !== undefined) {
    if (userPermissions.permissions !== undefined) {
      userPermissions.permissions.map((x) => permissions.push(x));
    }
  }
  const deleteButton = async () => {
    setOpen(true);
  };
  const isHidden =
    showVersionHistoryBar &&
    readOnlyMode &&
    selectedListItem !== null &&
    selectedListItem !== undefined;
  const handleClickOpen = async () => {
    setUndoEdits(true);
    setRedoEdits(true);
    setIsLoading(true);
    setOpen(false);
    const variables = {
      input: {
        id: parseInt(props.data.projectSkillId, 10),
      },
    };
    await deleteMember({
      variables,
    });
    props.deleteHandler();
  };

  const handleClose = () => {
    setOpen(false);
  };
  const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

  return (
    <span>
      <span>{cellValue}</span>
      {permissions.includes(CAN_EDIT_TEAM_MEMBERS) && (
        <DeleteIconButton
          sx={{ height: 24, width: 24 }}
          style={{
            display: isHidden ? 'none' : '',
            marginLeft: '21.33px',
          }}
          cursor="pointer"
          aria-label="delete"
          onClick={deleteButton}
        >
          <img src={deleteImg} alt="deleteButton" />
        </DeleteIconButton>
      )}
      <Dialog
        className="custom-modal-dialog confirmation-modal-dialog"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent className="dialog-content">
          <DialogContentText id="alert-dialog-description">
            You are deleting member permenently
          </DialogContentText>
          <DialogContentText>This change will update the timeline</DialogContentText>
          <DialogContentText>Do you want to proceed?</DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-actions">
          <Button primary outlined onClick={handleClose}>Cancel</Button>
          <Button primary onClick={handleClickOpen} autoFocus>Continue</Button>
        </DialogActions>
      </Dialog>
    </span>
  );
};
deleteIconButton.propTypes = propTypes;
export default deleteIconButton;
